var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndustryLeadingEdits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 525 500",
    style: {
      enableBackground: "new 0 0 525 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ED5338;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M480.8,18.5C469.1,6.4,453-0.3,436.3,0c-16.7,0.3-32.7,7.1-44.5,19L98.5,312.5c-0.9,0.8-1.6,1.7-2.2,2.8 l-94.5,166c-3,4.8-2.1,11.1,2,15c2.3,2.4,5.4,3.8,8.7,3.7c2.2,0,4.4-0.6,6.3-1.7L184.3,403l2.5-2L480,107.8 C491.9,96,498.7,80,498.8,63.3C499,46.6,492.5,30.5,480.8,18.5L480.8,18.5z M170.3,382l-125,71.7l71-125l217.5-217.5l53,53 L170.3,382z M462.2,90l-56.7,56.7l-53-53L409.2,37c7.2-7.4,16.9-11.7,27.2-12c10.1-0.5,19.8,3.4,26.8,10.7 c7.1,7.3,11,17.2,10.8,27.3C473.8,73.3,469.6,83,462.2,90L462.2,90z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512.5,475h-225c-6.9,0-12.5,5.6-12.5,12.5s5.6,12.5,12.5,12.5h225c6.9,0,12.5-5.6,12.5-12.5 S519.4,475,512.5,475z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryLeadingEdits);
export default __webpack_public_path__ + "static/media/industry_leading_edits.04ca4cf88b0310d50a90839a2472cae6.svg";
export { ForwardRef as ReactComponent };